import ProductListItem from "core/components/ProductListItem";
import { useEffect, useState } from "react";
import { useUserSuggestionMain } from "../hooks";
import SectionSkeleton from "./SectionSkeleton";
import { _t } from "core/language";
// import { RouterName } from "core/router";
// import { useGoToRecipeDetail } from "modules/Recipes/hooks/recipe";
import MainNodata from "./NodataComponent";
import { useGoToRecipeDetail } from "modules/Recipes/hooks/recipe";
import { RouterName } from "core/router";
import type { IRecipeDetail } from "modules/Recipes/store/types";
// import IconTitle from "../assets/images/icon_section_weather.svg";
import { getYouTubeThumbnail } from "core/utils/helper";
import IconSectionWeather from "./icon/IconSectionWeather";
import RefreshIconWhite from "../assets/icon/refresh-icon-white.svg";

const UserSuggestions = ({refresh}:any) => {
  const goToDetail = useGoToRecipeDetail(RouterName.INGREDIENT_RECIPE_DETAIL)
  const [paramsWeather, setParamsWeather] = useState({
    lat: '',
    lng: '',
    refresh: refresh
  });

  useEffect(() => {
    setParamsWeather({
      lat: '',
      lng: '',
      refresh: refresh,
    })
  }, [refresh]);

  const {userSuggestions, loading, reload} = useUserSuggestionMain(paramsWeather);
  // const [hasData, setHasData] = useState(userSuggestions?.length > 0);

  const handleClick = (data: any) => {
    goToDetail({
      id: data?.id || '',
      name: data?.name || '',
      thumbnail: data?.youtube_videos?.[0]?.thumbnail || '',
    } as IRecipeDetail);
  };

  const reLoadRecipeRandom = () => {
    console.log('reLoadRecipeRandom');
    if(loading) return;
    reload();
    // setHasData(false);
  };

  console.log(loading,'userSuggestions', userSuggestions);
  return (
    //rounded-tl-[24px] rounded-tr-[24px]
    <section className={`relative py-[20px]  w-full bg-[#FF6741]`}>
      <span className="px-4 text-xs font-normal text-white flex items-center justify-between">
        {_t("main.user_suggest_title1")}
        <img
          src={RefreshIconWhite}
          className="mt-1"
          alt=""
          onClick={reLoadRecipeRandom}
        />
      </span>
      <h1 className="text-[17px] font-bold text-[#FFF] pl-4 flex items-center">
        <div className="mr-1">
            <IconSectionWeather />
        </div>
        {
        _t("main.user_suggest_title2")
        }
      </h1>
      <div className="flex flex-col items-start overflow-x-scroll no-scrollbar">
        <div className="flex mt-3.5 gap-2 px-4">
          {(loading) && <SectionSkeleton width={140} height={140} count={10} />}
          {!loading && (userSuggestions.length > 0) && (userSuggestions || []).map((weather: any, index: any) => (
            <ProductListItem
              key={index}
              className="w-[140px] h-[140px] mb-0"
              image={weather?.video_id ? getYouTubeThumbnail(weather?.video_id) : weather?.youtube_videos?.[0]?.thumbnail}
              name={weather.name}
              {...weather}
              dataItem={weather}
              handleClick={handleClick}
            />
          ))}
        </div>
        <MainNodata loading={loading} data={userSuggestions} text={_t("main.no_data")} />
      </div>
    </section>
  );
};

export default UserSuggestions;
